import { ReactElement } from 'react';
import { infringementExtensionContactInfoDisplayObject, infringementExtensionCompanyInfoDisplayObject } from '@services/FormFieldConfig';
import CompanyInformationInfringementExtension from '@components/CompanyInformation/CompanyInformationInfringementExtension';
import { iInfringementExtensionFormValues } from '@services/InfringementExtensionService';
import { useFormikContext } from 'formik';
import { ContactInformationAccessible } from '@components/index';

function InfringementExtStep7(): ReactElement {
  const currentSp = 'Select if you do not have an email address';
  const { values }: { values: iInfringementExtensionFormValues; touched: any } = useFormikContext();
  return (
    <>
      {values.isDebtorTypeIndividual
      && <ContactInformationAccessible displayObject={infringementExtensionContactInfoDisplayObject} currentStep={currentSp} />}
      {values.isDebtorTypeCompany
      && <CompanyInformationInfringementExtension displayObject={infringementExtensionCompanyInfoDisplayObject} currentStep={currentSp} />}
    </>
  );
}

export default InfringementExtStep7;
